export const ERR_MSG_PASSWORD_EXPIRED =
  "Your password has expired. Please enter your username and email address and click RESET button. An email with the secure link will be sent to your email address. Please use the provided link. ";
export const ERR_MSG_INVALID_PASSWORD = "Invalid username or password";
export const ERR_MSG_SESSION_EXPIRED = "Session expired. Please login again.";
export const ERR_MSG_WRONG_SECURITY_QUESTION_ANSWER =
  "The answer to the security question does not match our records. Please try again.";
export const ERR_SELECT_ITEM_IN_LIST = "Please select an item in the list.";
export const ERR_CHECKBOX_NOT_CEHCKED =
  "Please check this box if you want to proceed.";
export const ERR_TEXTBOX_NOT_FILLED = "Please fill in this field.";
export const ERR_UNABLE_TO_HANDLE_REQUEST = "Unable to handle request";
export const ERR_INSUFFICIENT_INFORMATION = "Insufficient information";
export const ERR_NARROW_DOWN_SEARCH = "Narrow down search";
export const ERR_NO_RECORDS_FOUND = "No Records Found";
export const ERR_ANSWERS_NOT_FILLED = "Please enter all answers";



// WEBPACK FOOTER //
// ./src/ErrorMessages.js